import React from 'react';
import { Checkbox, CheckboxProps, SvgIcon } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { IndeterminateCheckBox } from '@material-ui/icons';

export const GreenCheck = withStyles({
  root: {
    '&$checked': {
      color: '#2BB073',
    },
  },
  checked: {},
})((props: CheckboxProps) => (
  <Checkbox
    color="default"
    indeterminateIcon={<IndeterminateCheckBox htmlColor="#2BB073" />}
    {...props}
  />
));

/** A filled box with an X through it, for a permission that cannot be granted at all. */
const CrossedBoxIcon = () => (
  <SvgIcon>
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2.3 13.3c-.39.39-1.02.39-1.41 0L12 13.41 8.71 16.7c-.39.39-1.02.39-1.41 0-.39-.39-.39-1.02 0-1.41L10.59 12 7.3 8.71c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L12 10.59l3.29-3.29c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L13.41 12l3.29 3.29c.38.38.38 1.02 0 1.4z" />
  </SvgIcon>
);

/**
 * Stands in for a checkbox on a permission the user is not eligible for. Always checked and
 * disabled - it reports a state rather than offering one - so the red has to survive the
 * disabled style.
 */
export const RedCross = withStyles({
  root: {
    '&$disabled': {
      color: '#C0392B',
    },
  },
  disabled: {},
})((props: CheckboxProps) => (
  <Checkbox color="default" checked disabled checkedIcon={<CrossedBoxIcon />} {...props} />
));
